import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';
import { AvailableDateRange, Period, PeriodRequest } from '@src/api/types/communityDashboard';
import { Pagination } from '@src/api/types/pagination';

export type ListParticipantRequest = {
  period: PeriodRequest;
  start_date: string;
  end_date: string;
  search?: string;
  sort?: string;
  direction?: 'asc' | 'desc';
  page?: string | number;
  keyword?: string;
};

export interface ListParticipant {
  id: number;
  company_name: string;
  full_name: string;
  stats_date: string;
  channels_count: number;
  posts: number;
  reactions: number;
  total_actions: number;
  last_accessed_at: string | null;
}

export type ListParticipantResponse = {
  period: Period;
  available_date_range: AvailableDateRange;
  data: ListParticipant[];
  pagination: Pagination;
  validation_messages: string[];
};

export const listParticipantApiClient = {
  index: async (params: ListParticipantRequest): Promise<ApiResult<ListParticipantResponse>> => {
    return await axiosClient.get('/tenant/dashboard/participant-stats', { params });
  },

  downloadCSV: async (params: ListParticipantRequest): Promise<ApiResult<Blob>> => {
    return await axiosClient.get('/tenant/dashboard/participant-stats/csv-export', {
      params,
      responseType: 'blob',
    });
  },
};
